export default __webpack_public_path__ + "8974395e71d24b4aceaaacd4160bbb6e.svg";